/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'welcome';
const componentName = 'welcome-service';
const prefix = `${moduleName}.${componentName}`;

export const welcomeLabel = `${prefix}.welcomeLabel`;

export const ENGLISH = {
    [welcomeLabel]: 'Welcome',
};
